//init
import * as Realm from 'realm-web';
const app = new Realm.App({ id: process.env.REACT_APP_MNDB_RELM_TRXN});


export const AuthCodeTrxn = async () => {
  const cred = Realm.Credentials.apiKey(process.env.REACT_APP_MNDB_AUTH_TRXN);
  const user = await app.logIn(cred);
  return user
}

// ------------------------ //
export const GetTransfersList = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.trxnGetTransfersList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const GetTransfersCount = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.trxnGetTransfersCount(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}


export const GetAccountTransactions = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.trxnGetAccountTransactions(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const GetPoapTransfers = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.trxnGetPoapList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const GetUserPoapTransfers = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.trxnGetUserPoapList(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}

export const CreatePoapTransfers = async (item) => {
  const trxnuser = await AuthCodeTrxn()
  const result = await trxnuser.functions.toknSendPoap(JSON.stringify({
    ...item, 
    webb: process.env.REACT_APP_WEBB_SITE_NMBR
  }));
  // console.log(result)
  return JSON.parse(result);
}